export const getLibrary = (provider) => {
  console.log(provider, "provider");
  return provider;
};
